import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SearchInventory from "./searchInventory";
import {
  faBuilding,
  faFileExcel,
  faPlus,
  faQrcode,
  faRectangleList,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  showAddNamesModal,
  showNewInventoryModal,
  setShowPrintQrCodeModal,
  setShowCreateRoomsInventory,
} from "../redux-state/features/inventory/inventorySlice";
import { clearCredentials } from "../redux-state/features/user/userSlice";
import urls from "../urls";

const InventoryNavBar = ({}) => {
  const user_type = useSelector((state) => state.userState.userType);
  const dispatch = useDispatch();

  const handleLogOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    dispatch(clearCredentials());
  };
  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary border-bottom mb-3">
      <div className="container-fluid">
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              إضافة بيانات
            </a>
            <ul className="dropdown-menu">
              <li>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={() => dispatch(showAddNamesModal("use_places"))}
                >
                  <FontAwesomeIcon icon={faBuilding} size="lg" />
                  <span className="mx-3">إضافة اسماء أماكن الاستغلال</span>
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={() => dispatch(showAddNamesModal("beneficiaries"))}
                >
                  <FontAwesomeIcon icon={faUserPlus} size="lg" />
                  <span className="mx-3">إضافة أسماء مستفيدين</span>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={() => dispatch(showNewInventoryModal())}
                >
                  <FontAwesomeIcon icon={faPlus} size="lg" />
                  <span className="mx-3">إضافة جرد جديد</span>
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  <FontAwesomeIcon icon={faFileExcel} size="lg" />
                  <span className="mx-3">تحميل جرد من إكسل </span>
                </a>
              </li>
            </ul>
          </li>
          <li className="nav-item ">
            <a
              className="nav-link"
              href="#"
              onClick={() => dispatch(setShowCreateRoomsInventory(true))}
            >
              إنشاء جرد للقاعات
            </a>
          </li>
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              طباعــة
            </a>
            <ul className="dropdown-menu">
              <li>
                <a
                  className="dropdown-item"
                  // href={urls.printMultipleInvQrCode}
                  // target="_blank"
                  href="#"
                  onClick={() =>
                    dispatch(
                      setShowPrintQrCodeModal({ bool: true, type: "QrCode" })
                    )
                  }
                >
                  <FontAwesomeIcon icon={faQrcode} size="lg" />
                  <span className="mx-3">طباعــة رمز الاستجابة السريعة</span>
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={() =>
                    dispatch(
                      setShowPrintQrCodeModal({
                        bool: true,
                        type: "InventorySheet",
                      })
                    )
                  }
                >
                  <FontAwesomeIcon icon={faRectangleList} size="lg" />
                  <span className="mx-3">طباعــة ورقة الجرد للقاعات</span>
                </a>
              </li>
            </ul>
          </li>
          {user_type === "inventory_officer" && (
            <li className="nav-item ">
              <a className="nav-link" href="/" onClick={handleLogOut}>
                خروج
              </a>
            </li>
          )}
        </ul>
        <div className="d-flex">
          <SearchInventory />
        </div>
      </div>
    </nav>
  );
};

export default InventoryNavBar;
